import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import RequestHelper from './RequestHelper';
import transformObjectResponseKeys from '../utils/transformObjectResponseKeys';
import { InitAppResponseKeys, UpdateAppEventResponseKeys, XPResponseKeys, FavouriteResponseKeys, Endpoints, LTOPackageItemKeys, OOCPackageItemKeys } from './Constants';
import transformObjectArrayResponse from '../utils/transformObjectArrayResponse';
import { EVENT_TYPES } from '../lib/analytics/constants';
import Logger from '../lib/analytics/logger';
import store from '../state/store';
import { setWelcomeBonus, setLTOOffer, setOutOfCoinOfferResponse, setTimedBonus, setIsWelcomeBonusConsumed } from '../state/slices/consumables/consumables';
import { setSaleAvailable, setPaymentProvider } from '../state/actions/shopList';
import { setCacheId } from '../state/actions/app';
import { setXpBetMultiplier } from '../state/slices/xp/xp';
import { setMaxDownloadedGames } from '../state/actions/gameDownload';
import { setWelcomeNews, setLobbyBackgroundPromo } from '../state/actions/promotions';
import { setAppsflyerGamesOpenedAmountConfig } from '../state/actions/playerInfo';
import { updateUnreadMessageCount } from '../state/actions/notification';
import { clearOnboarding, setFtueState, setFtueGameId } from '../state/actions/currentOnboarding';
import PushNotification from '../lib/notifications/PushNotification';
import QueryParamProxy from '../utils/queryParamProxy';
import Screens from '../screens';
import Utils from '../utils';
import TimeStampManager from '../utils/TimestampManager';
import RouteParamConstants from '../utils/routeParamConstants';
import ERROR_CODE from '../utils/errorCodes';
import { ltoCallBackHandler } from '../utils/function';
import { propertiesRequestData } from '../state/slices/properties/properties';
import { promoListHandler } from '../utils/PromotionAction';
import { getAssetsPackage } from '../state/query/assetsPackage';
export default {
  /**
   * Helper method to get kitchen sink info
   * @returns {Promise<InitAppResponseKeys>}
   */
  initApp: function () {
    var _initApp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _callResponse, _callResponse2, response, callResponse, coinBalance, loyaltyPoints, preloadAssetsPackageIds, loadAssets, loginData, diveItems, queryParams;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return RequestHelper.apiPost({
              endpoint: Endpoints.INIT_APP,
              logJSON: true
            }, false);
          case 3:
            response = _context2.sent;
            callResponse = !!response && response || Array(7).fill({});
            if (!(callResponse.success === false)) {
              _context2.next = 7;
              break;
            }
            throw Error("[Init-App-response] ".concat(callResponse.error));
          case 7:
            coinBalance = callResponse[3][0];
            loyaltyPoints = callResponse[3][2];
            callResponse = transformObjectResponseKeys(callResponse[0], InitAppResponseKeys);
            preloadAssetsPackageIds = ((_callResponse = callResponse) === null || _callResponse === void 0 ? void 0 : _callResponse.PRELOAD_ASSETS_PACKAGE_IDS) && _toConsumableArray(new Set(Object.values((_callResponse2 = callResponse) === null || _callResponse2 === void 0 ? void 0 : _callResponse2.PRELOAD_ASSETS_PACKAGE_IDS)));
            if ((preloadAssetsPackageIds === null || preloadAssetsPackageIds === void 0 ? void 0 : preloadAssetsPackageIds.length) > 0) {
              loadAssets = /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return Promise.all(preloadAssetsPackageIds.map(function (assetsPackageId) {
                          return store.dispatch(getAssetsPackage.initiate({
                            assetsPackageId: assetsPackageId
                          })).unwrap();
                        }));
                      case 2:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function loadAssets() {
                  return _ref.apply(this, arguments);
                };
              }();
              loadAssets();
            }
            callResponse.PAYMENT_PROVIDER && store.dispatch(setPaymentProvider(callResponse.PAYMENT_PROVIDER));
            callResponse.APPSFLYER_GAMES_OPENED && store.dispatch(setAppsflyerGamesOpenedAmountConfig(callResponse.APPSFLYER_GAMES_OPENED));

            // Call initProperty
            store.dispatch(propertiesRequestData());

            // Update CacheId
            if (callResponse.CACHE_ID) store.dispatch(setCacheId(callResponse.CACHE_ID));
            if (callResponse.MAX_DOWNLOADED_GAMES) store.dispatch(setMaxDownloadedGames(callResponse.MAX_DOWNLOADED_GAMES));
            if (callResponse.ENABLE_FTUE != 'yes') store.dispatch(clearOnboarding());else {
              store.dispatch(setFtueState(true));
              if (callResponse.TUTORIAL_ID) store.dispatch(setFtueGameId(callResponse.TUTORIAL_ID));
            }
            if (callResponse.XP || callResponse.XP === 0) callResponse.XP = transformObjectResponseKeys(callResponse.XP, XPResponseKeys);
            callResponse.PROMOTIONS = transformObjectArrayResponse(callResponse.PROMOTIONS);
            callResponse.PROMOTIONS_SECOND = transformObjectArrayResponse(callResponse.PROMOTIONS_SECOND);
            callResponse.PROMOTIONS_THIRD = transformObjectArrayResponse(callResponse.PROMOTIONS_THIRD);
            callResponse.WELCOME = transformObjectArrayResponse(callResponse.WELCOME);
            if (callResponse.XP) {
              callResponse.XP.CURRENT_XP = parseInt(callResponse.XP.CURRENT_XP);
              callResponse.XP.XP_BET_MULTIPLIER = parseFloat(callResponse.XP.XP_BET_MULTIPLIER);
              callResponse.XP.XP_PER_SPIN = parseInt(callResponse.XP.XP_PER_SPIN);
            }
            if (callResponse.SETTINGS) {
              callResponse.SETTINGS.kyocInfo = {
                iskyocdone: callResponse.SETTINGS.kyocInfo.iskyocdone === 'yes',
                kyocresult: callResponse.SETTINGS.kyocInfo.kyocresult,
                info: callResponse.SETTINGS.kyocInfo.info
              };
              callResponse.SETTINGS.soundEffects = callResponse.SETTINGS.soundEffects === 'true';
              callResponse.SETTINGS.music = callResponse.SETTINGS.music === 'true';
            }
            if (callResponse.FAVOURITE) {
              callResponse.FAVOURITE = transformObjectResponseKeys(callResponse.FAVOURITE, FavouriteResponseKeys);
            }
            callResponse.TUTORIAL = callResponse.TUTORIAL === 'yes';
            loginData = Logger.loginData;
            if (loginData === null) {
              loginData = {
                type: '',
                email: ''
              };
              if (callResponse.CASINO_ID_STATUS === 'Guest') {
                loginData.type = 'guest';
              }
              if (callResponse.SETTINGS) {
                if (callResponse.SETTINGS.facebookId !== '') {
                  loginData.type = 'facebook';
                }
                if (callResponse.SETTINGS.googleId !== '') {
                  loginData.type = 'google';
                }
              }
            }
            diveItems = {};
            if (callResponse.CASINO_ID_STATUS === 'Guest') diveItems.loginMethod = 'guest';else {
              if (callResponse.SETTINGS && callResponse.SETTINGS.facebookId !== '') diveItems.loginMethod = 'facebook';
              if (callResponse.SETTINGS && callResponse.SETTINGS.googleId !== '') diveItems.loginMethod = 'google';
            }
            diveItems.userXP = callResponse.XP.CURRENT_XP;
            diveItems.userLevel = callResponse.XP.LEVEL_META.currentLevel;
            diveItems.sessionId = store.getState().token.token;
            queryParams = QueryParamProxy.getAllParams();
            Logger.sendEvent(EVENT_TYPES.LOGIN_COMPLETE, {
              curr_xp: !!callResponse.XP && callResponse.XP.CURRENT_XP || 0,
              tier_id: !!callResponse.CURRENT_MEMBER_LEVEL && callResponse.CURRENT_MEMBER_LEVEL || 0,
              balance_before: coinBalance,
              loyalty_points_before: loyaltyPoints,
              is_member_linked: !!callResponse.SETTINGS && !!callResponse.SETTINGS.linkedCasinoId && callResponse.SETTINGS.linkedCasinoId === 'yes' && 1 || 0,
              is_notification_on: PushNotification.notificationsEnabled ? 1 : 0,
              verification_status: callResponse.CASINO_ID_STATUS,
              email: loginData.email,
              login_type: loginData.type,
              fb_id: !!callResponse.SETTINGS && callResponse.SETTINGS.facebookId || null,
              google_id: !!callResponse.SETTINGS && callResponse.SETTINGS.googleId || null,
              userID: store.getState().playerInfo.playerId,
              diveItems: diveItems,
              queryParams: queryParams
            });
            if (callResponse.WELCOMEBONUS != '') store.dispatch(setWelcomeBonus(callResponse.WELCOMEBONUS));
            if (callResponse.WELCOMEBONUS != '' && !callResponse.TUTORIAL === 'no') store.dispatch(setIsWelcomeBonusConsumed(false));
            return _context2.abrupt("return", callResponse);
          case 41:
            _context2.prev = 41;
            _context2.t0 = _context2["catch"](0);
            Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
              error: JSON.stringify(_context2.t0, Object.getOwnPropertyNames(_context2.t0)),
              code: ERROR_CODE.APP_INTERFACE_INIT_APP_CATCH
            });
            throw _context2.t0;
          case 45:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 41]]);
    }));
    function initApp() {
      return _initApp.apply(this, arguments);
    }
    return initApp;
  }(),
  updateAppEvents: function () {
    var _updateAppEvents = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var response, callResponse, ltoResponse, messagesFromResponse, msgcount, outOfCoinsResponse, i, welcomeNewsReceivedPromise;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return RequestHelper.apiGet({
              endpoint: Endpoints.UPDATE_APP_EVENT_INFO,
              logJSON: true
            }, false);
          case 3:
            response = _context3.sent;
            callResponse = !!response && response || Array(7).fill({});
            if (!(callResponse.success === false)) {
              _context3.next = 7;
              break;
            }
            throw Error("[Update-App-events-response] ".concat(callResponse.error));
          case 7:
            callResponse = transformObjectResponseKeys(callResponse[0], UpdateAppEventResponseKeys);

            // Update LTO
            if (callResponse.LIMITED_TIME_OFFER) {
              ltoResponse = transformObjectResponseKeys(callResponse.LIMITED_TIME_OFFER, LTOPackageItemKeys);
              ltoResponse.OFFER_END_TIME = ltoResponse.TIME_LEFT_IN_SEC * 1000 + Date.now();
              store.dispatch(setLTOOffer(ltoResponse));
              TimeStampManager.register(ltoResponse.TIME_LEFT_IN_SEC * 1000, ltoCallBackHandler(store, setLTOOffer));
            }

            // Unread Message count
            if (callResponse.MESSAGES && callResponse.MESSAGES.messages) {
              messagesFromResponse = transformObjectArrayResponse(callResponse.MESSAGES.messages);
              if (messagesFromResponse.length > 0) {
                msgcount = messagesFromResponse.filter(function (msg) {
                  return !Utils.isEmpty(msg) && msg.message_read !== 'yes';
                }).length;
                store.dispatch(updateUnreadMessageCount(msgcount));
              }
            }

            // Update out of coins data
            if (callResponse.OUT_OF_COINS) {
              outOfCoinsResponse = transformObjectResponseKeys(callResponse.OUT_OF_COINS, OOCPackageItemKeys);
              store.dispatch(setOutOfCoinOfferResponse(outOfCoinsResponse));
            }

            // Update Promotions
            promoListHandler({
              first_slide: transformObjectArrayResponse(callResponse.PROMOTIONS),
              second_slide: transformObjectArrayResponse(callResponse.PROMOTIONS_SECOND),
              third_slide: transformObjectArrayResponse(callResponse.PROMOTIONS_THIRD)
            });

            // Update Timed Bonus
            if (callResponse.TIMED_BONUS) {
              callResponse.TIMED_BONUS.timeLeft = Date.now() + callResponse.TIMED_BONUS.timeLeft * 1000;
              store.dispatch(setTimedBonus(callResponse.TIMED_BONUS));
            }

            // Update Sale
            store.dispatch(setSaleAvailable(callResponse.SALE));

            // Update XP Bet Multiplier
            if (callResponse.XP_BOOST_MULTIPLIER) {
              store.dispatch(setXpBetMultiplier(callResponse.XP_BOOST_MULTIPLIER));
            }

            // Update Welcome news
            callResponse.WELCOME = transformObjectArrayResponse(callResponse.WELCOME);
            if (!(callResponse.WELCOME && callResponse.WELCOME.length > 0)) {
              _context3.next = 26;
              break;
            }
            i = 0;
          case 18:
            if (!(i < callResponse.WELCOME.length)) {
              _context3.next = 26;
              break;
            }
            store.dispatch(setWelcomeNews(callResponse.WELCOME[i]));
            welcomeNewsReceivedPromise = QueryParamProxy.setQueryParamsWithModalPromise(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.News));
            _context3.next = 23;
            return welcomeNewsReceivedPromise;
          case 23:
            i++;
            _context3.next = 18;
            break;
          case 26:
            // Update Lobby Background
            if (callResponse.LOBBY_BACKGROUND) {
              store.dispatch(setLobbyBackgroundPromo(callResponse.LOBBY_BACKGROUND));
            }
            _context3.next = 33;
            break;
          case 29:
            _context3.prev = 29;
            _context3.t0 = _context3["catch"](0);
            Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
              error: JSON.stringify(_context3.t0, Object.getOwnPropertyNames(_context3.t0)),
              code: ERROR_CODE.UPDATE_APP_EVENTS_FAIL
            });
            throw _context3.t0;
          case 33:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[0, 29]]);
    }));
    function updateAppEvents() {
      return _updateAppEvents.apply(this, arguments);
    }
    return updateAppEvents;
  }(),
  /** Only relevant on the web, baked in at build time for mobile. */getFacebookAppId: function () {
    var _getFacebookAppId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var callResponse;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return RequestHelper.apiGet({
              endpoint: Endpoints.GET_FB_APP_ID
            }, false);
          case 2:
            callResponse = _context4.sent;
            return _context4.abrupt("return", callResponse && callResponse['0'] ? callResponse['0'] : false);
          case 4:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    function getFacebookAppId() {
      return _getFacebookAppId.apply(this, arguments);
    }
    return getFacebookAppId;
  }()
};